// src/pages/Inicio.jsx
import React, {useEffect} from 'react';
import Paper from '@mui/material/Paper';
import {
    fetchOrdensServico,
    geraOrdemServico,
    geraInsumos,
    alteraInsumosOS,
    encerraOS,
    fetchNotasRetorno,
    fetchTabelaPrecoCompras,
} from '../../services/easyhubQueries';

export default function Inicio() {
    // useEffect(() => {
    //     (async () => {
    //         try {
    //             // 1. Ordens de serviço
    //             const ordens = await fetchOrdensServico();
    //             console.log('fetchOrdensServico:', ordens);

    //             // 2. Gera OS
    //             const geraOSres = await geraOrdemServico(
    //                 '077LOC',
    //                 '001LOC',
    //                 '3000251001001DMG01',
    //                 '35000',
    //             );
    //             console.log('geraOrdemServico:', geraOSres);

    //             // 3. Gera Insumos
    //             const insumosPayload = [
    //                 {
    //                     TipoInsumo: 'P',
    //                     CodInsumo: 'PROD_MNT_0001',
    //                     Qtd: '10',
    //                     VlrUnit: '50.0',
    //                     VlrTotal: '500.0',
    //                     Destino: 'A',
    //                     CodForn: 'FORN001',
    //                     LojForn: '001',
    //                     NomeForn: 'Fornecedor Exemplo',
    //                     Stapro: '2',
    //                     CodApr: '00001',
    //                     NomApr: 'A',
    //                     DtApro: '2025-05-15',
    //                     HrApro: '09:00',
    //                     DtEnc: '2025-05-15',
    //                     HrEnc: '09:00',
    //                     PedCom: '999999',
    //                     VlUnApr: '50.0',
    //                     VlTotApr: '500.0',
    //                     CusExtra: '500.0',
    //                     Cobra: 'S',
    //                     CodFinGer: '000001',
    //                     DesFinGer: 'TESTE',
    //                     Justificativa: 'Motivo da inclusao',
    //                     Anexos: [
    //                         {name: 'anexo_item1.jpg', size: '25600', base64: 'base64string'},
    //                         {name: 'anexo2_item1.jpg', size: '25600', base64: 'base64string'},
    //                     ],
    //                 },
    //             ];
    //             const insumosRes = await geraInsumos('002228', insumosPayload);
    //             console.log('geraInsumos:', insumosRes);

    //             // 4. Altera Insumos da OS
    //             const alteraPayload = [
    //                 {
    //                     produto: '00001298',
    //                     qtd: '30.0',
    //                     valor_uni: '10.0',
    //                     seq_tar: '001',
    //                     Anexos: [
    //                         {name: 'anexo_item1_DENNIS.jpg', size: '25600', base64: 'base64string'},
    //                         {
    //                             name: 'anexo2_item1_DENNIS2.jpg',
    //                             size: '25600',
    //                             base64: 'base64string',
    //                         },
    //                     ],
    //                 },
    //                 // adicionar outros itens se quiser testar múltiplos
    //             ];
    //             const alteraRes = await alteraInsumosOS('000279', alteraPayload);
    //             console.log('alteraInsumosOS:', alteraRes);

    //             // 5. Encerra OS
    //             const encerraRes = await encerraOS('002235');
    //             console.log('encerraOS:', encerraRes);

    //             // 6. Notas de retorno (Query 08)
    //             const notasRetorno = await fetchNotasRetorno();
    //             console.log('fetchNotasRetorno:', notasRetorno);

    //             // 7. Tabela de preço de compras (Query 09)
    //             const tabelaPreco = await fetchTabelaPrecoCompras();
    //             console.log('fetchTabelaPrecoCompras:', tabelaPreco);
    //         } catch (error) {
    //             console.error('Erro nas chamadas iniciais:', error);
    //         }
    //     })();
    // }, []);

    return (
        <Paper
            elevation={1}
            sx={{
                p: 0,
                borderRadius: 3,
                height: '100%',
                width: '100%',
                overflow: 'hidden',
            }}
        >
            <iframe
                src="https://develop.totvsnews.engpro.totvs.com.br/sigaloc/bra/por"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    display: 'block',
                    overflow: 'hidden',
                }}
                title="Sigaloc"
            />
        </Paper>
    );
}
